import Avatar from 'components/Avatar'
import DoughnutChart from 'components/Charts/DoughnutChart'
import Facebook from 'components/icons/Facebook'
import Instagram from 'components/icons/Instagram'
import LinkedinIcon from 'components/icons/LinkedinIcon'
import Twitter from 'components/icons/Twitter'
import LeftSection from 'modules/Roles/Partials/ViewCollegeDetails/Partials/CollegeInfo/About/LeftSection'
import React, { useEffect, useState } from 'react'
import { COLORS } from 'theme'

import {
  CapsSmall,
  FlexWrap,
  GreyText,
  Left,
  Links,
  Right,
  StyledDivider,
  StyledP,
  SubtitleLarge,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/Styles/style'

const About = ({ instituteCampusDetails, instituteDetails, draftData }) => {
  const [socialMedias, setSocialMedias] = useState([])

  useEffect(() => {
    const availableMedia = instituteCampusDetails?.socialMedia?.map(item =>
      item?.media == 'Facebook'
        ? {
            ...item,
            icon: <Facebook />,
          }
        : item?.media == 'Twitter'
        ? {
            ...item,
            icon: <Twitter />,
          }
        : item?.media == 'Linkedin'
        ? {
            ...item,
            icon: <LinkedinIcon />,
          }
        : item?.media == 'Instagram'
        ? {
            ...item,
            icon: <Instagram />,
          }
        : item
    )
    setSocialMedias(availableMedia)
  }, [instituteCampusDetails])

  return (
    <FlexWrap gap={'20px'} spaceBetween>
      {instituteCampusDetails?.longDescription && (
        <Left width={'50%'}>
          <LeftSection instituteCampusDetails={instituteCampusDetails} />
        </Left>
      )}
      <Right
        width={instituteCampusDetails?.longDescription ? '40%' : '60%'}
        column
      >
        {draftData?.isRankingActive && (
          <FlexWrap border="1px" alignCenter column>
            <GreyText>Average Student Rating</GreyText>
            <DoughnutChart
              width={160}
              totalValue={5}
              currentValue={
                instituteDetails?.[0]?.candidateAvgRating
                  ? Number(instituteDetails?.[0]?.candidateAvgRating)?.toFixed(
                      2
                    )
                  : 0
              }
            />
          </FlexWrap>
        )}
        <FlexWrap border="1px" column>
          <SubtitleLarge>
            {instituteCampusDetails?.campusName} {instituteCampusDetails?.city}
          </SubtitleLarge>
          <StyledP color={COLORS.GREY_T_50_2}>
            {instituteCampusDetails?.addressLine1}{' '}
            {instituteCampusDetails?.addressLine2}{' '}
            {instituteCampusDetails?.postalCode}
          </StyledP>

          <StyledDivider />

          <CapsSmall>Contact</CapsSmall>
          <FlexWrap padding="0" gap="10px">
            <Avatar
              background
              src={''}
              size={40}
              IconName={instituteCampusDetails?.contactPerson?.charAt(0)}
            />
            <FlexWrap column gap="0" padding="0">
              <GreyText color={COLORS.GREY_T_20}>
                {instituteCampusDetails?.contactPerson}
              </GreyText>
              <StyledP color={COLORS.GREY_T_50_2}>
                {instituteCampusDetails?.contactPersonRole}
              </StyledP>
            </FlexWrap>
          </FlexWrap>

          <FlexWrap padding="20px 0 5px 0">
            <StyledP width="148px">Contact Number</StyledP>
            <Links href={`tel:+91${instituteCampusDetails?.contactNumber}`}>
              +91 {instituteCampusDetails?.contactNumber}
            </Links>
          </FlexWrap>
          <FlexWrap padding="10px 0 5px 0">
            <StyledP width="148px">Email Id</StyledP>
            <Links href={`mailto:${instituteCampusDetails?.contactEmail}`}>
              {instituteCampusDetails?.contactEmail}
            </Links>
          </FlexWrap>

          <StyledDivider />

          <FlexWrap padding="5px 0">
            <StyledP width="148px">Website</StyledP>
            <Links
              width={'65%'}
              title={instituteCampusDetails?.website}
              href={instituteCampusDetails?.website}
              target="blank"
            >
              {instituteCampusDetails?.website}
            </Links>
          </FlexWrap>

          <FlexWrap padding="5px 0">
            {socialMedias?.length > 0 && (
              <StyledP width="148px">Social</StyledP>
            )}
            <FlexWrap padding="0" gap="10px" alignCenter>
              {socialMedias?.map((item, index) => (
                <Links
                  href={item?.link}
                  title={item?.link}
                  target="blank"
                  key={index + item?.link}
                >
                  {item?.icon}
                </Links>
              ))}
            </FlexWrap>
          </FlexWrap>
        </FlexWrap>
      </Right>
    </FlexWrap>
  )
}

export default About
